import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import {
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import EditIcon from '@mui/icons-material/Edit';

export const Context = createContext();
const AgregarContactoScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [convenioPago, setConvenioPago] = useState({
    idmedio: -99,
    mediocontacto: "",
    medio: "",
    comentarios: "",
  });
  const [data, setData] = useState([])

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    request
      .get(`AgregarContacto/Listado?idcliente=${state.idcliente}`)
      .then((result) => {
        setData(result);
      })
      .catch((error) => {
        JSON.stringify("PERMISOS", "ERROR....", "error");
      });
  }, []);



  const regresar = () => {
    history.push(
      "/Creditoycobranza/ListadoConvenios",
      {
        idcliente: state.idcliente,
        razonsocial: state.razonsocial
      }
    )
  };



  const guardarConvenio = () => {
    if (convenioPago.mediocontacto === "" || convenioPago.mediocontacto === null || convenioPago.mediocontacto === undefined) {
      Swal.fire({
        title: "AGREGAR CONTACTO",
        text: "SELECCIONE EL MEDIO DE CONTACTO",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    if (convenioPago.medio === "" || convenioPago.medio === null || convenioPago.medio === undefined) {
      Swal.fire({
        title: "AGREGAR CONTACTO",
        text: "SE NECESITA AGREGAR EL CORREO O TELEFONO",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }

    setLoader({ ...loader, mostrar: true });
    const post = {
      idmedio: convenioPago.idmedio,
      idcliente: state.idcliente,
      mediocontacto: convenioPago.mediocontacto,
      medio: convenioPago.medio,
      comentarios: convenioPago.comentarios
    };
    request
      .post(`AgregarContacto/Guardar`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result)
        setConvenioPago({
          ...convenioPago,
          idmedio: -99,
          mediocontacto: "",
          medio: "",
          comentarios: "",
        })
        await Swal.fire({
          title: "AGREGAR CONTACTO",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };

  const onCancelar = () => {
    setConvenioPago({
      ...convenioPago,
      idmedio: -99,
      mediocontacto: "",
      medio: "",
      comentarios: "",
    })
  }

  const onEditar = (idmedio) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AgregarContacto/BuscarID?idmedio=${idmedio}`)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        setConvenioPago({
          ...convenioPago,
          idmedio: result.idmedio,
          mediocontacto: result.mediocontacto,
          medio: result.medio,
          comentarios: result.comentarios
        })
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  }

  //REPORTE CONVENIO FACTURAS SELECCIONADAS
  return (
    <PlantillaScreen
      titulo={"MEDIOS DE CONTACTO DE " + state.razonsocial}
      className={"agregar-contacto-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="datos-agregar-contacto">
        <div className="agregar-contacto-detalle">
          <div className="agregar-contacto-detalle-formulario">
            <div className="agregar-contacto-formulario-plantilla">
              <div
                className={`agregar-contacto-formulario-plantilla-agregar`}
              >
                <div className="agregar-contacto-formulario-plantilla-container scroll-4">
                  <div className="agregar-contacto-formulario-plantilla-container-titulo">
                    Agregar Contacto Nuevo
                  </div>

                  <TextField
                    className="input-medio-comunicacion"
                    fullWidth
                    size="small"
                    label="Medio de Contacto"
                    select
                    type="text"
                    value={convenioPago.mediocontacto}
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        mediocontacto: e.target.value,
                      });
                    }}
                    sx={{ mt: 2 }}
                  >
                    <MenuItem value={"LL"}>LLAMADA TELEFONICA</MenuItem>
                    <MenuItem value={"WH"}>WHATSAPP</MenuItem>
                    <MenuItem value={"CO"}>CORREO</MenuItem>
                  </TextField>

                  <TextField
                    id="outlined-multiline-static"
                    label={convenioPago.mediocontacto === "CO" ? "Correo" : "Teléfono"}
                    size="small"
                    sx={{ mt: 2 }}
                    value={convenioPago.medio}
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        medio: e.target.value
                      });
                    }}
                    inputProps={{
                      maxLength: convenioPago.mediocontacto === "CO" ? undefined : 10
                    }}
                  />

                  <TextField
                    id="outlined-multiline-static"
                    label="Comentarios"
                    sx={{ mt: 2 }}
                    value={convenioPago.comentarios}
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        comentarios: e.target.value
                      });
                    }}
                  />
                </div>
                <div className="agregar-contacto-buttons">
                  <button
                    className="agregar-contacto-button-guardar"
                    onClick={() => guardarConvenio()}
                  >
                    Agregar
                  </button>
                </div>
              </div>
              <div className="home-agregar-contacto">
                {convenioPago.idmedio !== -99 ? (
                  <div
                    className="convenio-pago-button-cancelar"
                    onClick={() => onCancelar()}
                  >
                    {/* <ArrowBackIcon />  */}
                    Cancelar
                  </div>
                ) : (
                  <div
                    className="convenio-pago-button-cancelar"
                    onClick={() => regresar()}
                  >
                    {/* <ArrowBackIcon />  */}
                    Regresar
                  </div>
                )}

              </div>
            </div>
          </div>
          <div className="agregar-contacto-listado-medios-contacto-container scroll-4">
            <table>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>
                    <div>Medio</div>
                  </th>
                  <th>
                    <div>Preferencia</div>
                  </th>
                  <th>
                    <div>Comentarios</div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr>
                    <td className="ta-center">{item.tipomedio}</td>
                    <td className="ta-center">{item.medio}</td>
                    <td className="ta-center">{item.mediocontacto}</td>
                    <td className="ta-center">{item.comentarios}</td>
                    <td>
                      <EditIcon color="warning" className="edit-button" onClick={() => onEditar(item.idmedio)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};

export default AgregarContactoScreen;

